export const generateCaseNumber = () => {
  const random = Math.floor(Math.random() * 900000 + 100000);
  return `UW-${random}`;
};

export const normalizeCaseData = (item = {}, fallback = {}) => {
  const source = { ...fallback, ...item };
  const statusValue = typeof source.status === "string" ? source.status : "Processing";
  return {
    id: source.id || source.caseId || source.case_id || `case-${Date.now()}`,
    caseNumber: source.caseNumber || source.case_number || generateCaseNumber(),
    name: source.name || "New Borrower",
    email: source.email || "",
    loanType: source.loanType || source.loan_type || "Conventional",
    status: statusValue,
    date: source.date || source.createdAt || "Just now",
    propertyAddress: source.propertyAddress || source.property_address || "",
    loanAmount: source.loanAmount || source.loan_amount || "",
    documents: (source.documents || source.files || []).map((doc) => ({
      ...doc,
      objectKey: doc.objectKey || doc.object_key || null,
      // Use latest presigned URLs from API
      previewUrl: doc.signedUrl || doc.previewUrl || doc.downloadUrl || null,
      downloadUrl: doc.signedUrl || doc.downloadUrl || doc.previewUrl || null,
      signedUrl: doc.signedUrl || null,
      type: doc.type || doc.contentType || "application/pdf",
      contentType: doc.contentType || doc.type || "application/pdf"
    })),
    aiReports: source.aiReports || source.ai_reports || [],
    comments: source.comments || []
  };
};

export const formatFileSize = (size) => {
  if (!size && size !== 0) return "";
  const kb = size / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
};
